// Yawaraka Jazz 商品ページ（製品詳細ページ 案 3「壁と床」）。試作 mock-3d の src/tee/pdp.js・pdp3.js を Shopify 用に 1 本へ。
// 色・サイズ → バリアント（hidden の id）・価格・写真・カメレオンの色。部屋は購入欄の下に KV の並びのまま置く
(() => {
  const data = JSON.parse(document.getElementById('yj-product').textContent);
  const ja = data.lang === 'ja';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  // 生地色（試作 product.js の TEE_COLORS / LS_COLORS）
  const HEX = {
    'White': '#f4f4f1', 'Ivory': '#f3ecd6', 'Sandstone': '#958c71', 'Grey': '#95948f', 'Pepper': '#55524f', 'Black': '#1f1f20',
    'Butter': '#f6dfa4', 'Mustard': '#f2b95e', 'Terracotta': '#ee9268', 'Brick': '#8b4b55', 'Chambray': '#d4ecf7', 'Blue Jean': '#717f8e',
    'True Navy': '#232f4b', 'Blue Spruce': '#4e6253', 'Moss': '#6c7155', 'Blossom': '#f7d6e0',
    'Sand': '#d2c1a6', 'Light Blue': '#a2c0e0', 'Indigo Blue': '#4f6f93', 'Forest Green': '#243d24', 'Military Green': '#524f3f',
    'Navy': '#19263a', 'Maroon': '#6c182d', 'Light Pink': '#f6b6cd', 'Mixed Grey': '#b4b4b4',
    // Printstar 00085-CVT（日本版・Printful の color_code）
    'Smoke black': '#2e2c29', 'Purple': '#59276e', 'Burgundy': '#87202c', 'Army Green': '#45402a', 'Red': '#e01d24', 'Charcoal': '#57504e',
    'Heather Gray': '#c9c6c5', 'Heather gray': '#c9c6c5', 'Natural': '#f8eace', 'Heather Oatmeal': '#fcfcf5', 'Mint Green': '#57ebbe',
  };
  const DARK = new Set(['Pepper', 'Black', 'Brick', 'Blue Jean', 'True Navy', 'Blue Spruce', 'Moss', 'Indigo Blue', 'Forest Green', 'Military Green', 'Navy', 'Maroon', 'Smoke black', 'Purple', 'Burgundy', 'Army Green', 'Charcoal']);
  const hexOf = c => HEX[c] || '#84b8b3';
  // 部屋のカメレオンの体の色。濃い色は黒い輪郭線が見えなくなるので白で薄める（色の系統は残す）
  const chamOf = c => DARK.has(c) ? `color-mix(in srgb, ${hexOf(c)} 58%, #fff)` : hexOf(c);

  const form = document.getElementById('yj-buy');
  const idInput = form.querySelector('[data-variant]');
  const cta = form.querySelector('.bb__cta');
  // サイズは最初は選ばない（返品できない店なので、選ぶまで買えない。10/26 点検 #16）。URL の ?variant= は色だけ受け取る
  const urlVar = Number(new URL(location.href).searchParams.get('variant')) || 0;
  const first = data.variants.find(v => v.id === urlVar) || data.variants.find(v => v.color === idInput.dataset.color) || data.variants[0];
  const st = { color: first.color, size: null };
  // お届けできない国（英国・EU など）と分かっている間は買えない（snippets/yj-geo.liquid が window.YJ_NA に国コードを入れる。#27）
  const na = window.YJ_NA || null;
  const ETSY_BTN = true;    // 商品ごとの Etsy ボタンを本番で出すなら true（それまでは ?preview=etsy だけ）
  const ETSY_SHIPTO = true;    // 国選択の下の Etsy への一行を本番で出すなら true（それまでは ?preview=etsy だけ）
  { const el = document.querySelector('[data-etsy-shipto]'); if (el && (ETSY_SHIPTO || /[?&]preview=etsy\b/.test(location.search))) el.hidden = false; }
  const fns = [];
  const set = patch => { Object.assign(st, patch); const changed = Object.keys(patch); fns.forEach(f => f(changed)); };
  const variant = () => st.size ? data.variants.find(v => v.color === st.color && v.size === st.size) : undefined;

  // ---- 国ごとの「近くの工場」 ----
  // Printful は在庫のある工場のうち届け先にいちばん近い所へ自動で注文を回す（手で選べない）。yj-geo.js（shopify-tools/make-geo.py が作る）が
  // 色 × サイズごとの在庫の地域。お客さんの国に工場があるとき、その工場で作れる色を先に並べて見分けられるようにする
  const GEO = (window.YJ_GEO && window.YJ_GEO.p[data.ls ? '57' : '586']) || {};
  // 日本版（United Athle 5508）は全色が日本の工場で刷られ、日本・東アジアにしか届かない
  const blocked = !!data.jp && !data.ea;
  const NEAR = { JP: 'JP', US: 'US', CA: 'CA', AU: 'AU' }[data.country] || null;
  const PLACE = { JP: ['日本', 'Japan'], US: ['米国', 'the US'], CA: ['カナダ', 'Canada'], AU: ['オーストラリア', 'Australia'], EU: ['EU', 'the EU'], UK: ['英国', 'the UK'] };
  const placeOf = k => (PLACE[k] || PLACE.US)[ja ? 0 : 1];
  // 日数はご注文から到着まで（Printful の商品ページの目安、10/18）
  const DAYS = {
    near: { JP: ['6〜8 営業日', '6–8 business days'], US: ['6〜8 営業日', '6–8 business days'], CA: ['4〜7 営業日', '4–7 business days'], AU: ['6〜9 営業日', '6–9 business days'] },
    far: { JP: ['11〜14 営業日', '11–14 business days'], CA: ['13〜16 営業日', '13–16 business days'], AU: ['12〜20 営業日', '12–20 business days'], WORLD: ['2〜5 週間', '2–5 weeks'] },
  };
  const regs = (c, s) => data.jp ? ['JP'] : ((GEO[c] || {})[s] || '').split(' ').filter(Boolean);
  const sold = c => data.variants.filter(v => v.color === c);
  const nearAt = (c, s) => !!NEAR && regs(c, s).includes(NEAR);
  const nearColor = c => !!NEAR && sold(c).some(v => nearAt(c, v.size));
  // URL で色を指定されていなければ、近くの工場で作れる色を最初に選んでおく（サイズは選ばない）
  if (NEAR && !urlVar && !nearColor(st.color)) {
    const v = data.variants.find(x => x.available && nearAt(x.color, x.size));
    if (v) st.color = v.color;
  }
  for (const r of form.querySelectorAll('input[name=yj-color]')) r.checked = r.value === st.color;

  // ---- 色の丸（全色見える） ----
  // 並びは試作と同じ「並べて気持ちいい」順（HEX の順）。Shopify の登録順（黒が先頭）は使わない
  const order = Object.keys(HEX), pick = form.querySelector('.cpick');
  [...pick.children].sort((a, b) => order.indexOf(a.dataset.color) - order.indexOf(b.dataset.color)).forEach(el => pick.append(el));
  const PICKS = new Set();   // おすすめの★は 10/26 本人指示で外した
  for (const lab of form.querySelectorAll('.sw')) {
    if (PICKS.has(lab.dataset.color)) lab.classList.add('is-pick');
    const c = lab.dataset.color;
    lab.style.setProperty('--c', hexOf(c));
    if (DARK.has(c)) lab.classList.add('sw--dark');
  }
  // 届け方（工場）を選ぶ欄。国に近い工場を「おすすめ」で先に選び、ほかの工場も選べる（色が増える代わりに日数・関税がかかる）。
  // 選んだ工場で作れる色だけを下に並べる。半袖は近くの工場で刷れるのが別の商品（日本版）なので、その選択肢は日本版のページへのリンク
  const T = (j, e) => ja ? j : e;
  const days = (d) => T(d[0], d[1]);
  const farDays = NEAR === 'JP' ? DAYS.far.JP : (DAYS.far[NEAR] || DAYS.far.WORLD);
  // 米国の工場など国外から届く分の、受け取り時に払う関税・税金の見込み（国ごとのルールは yj-duty.js。1 枚の場合）。
  // 調べて確かめた国だけ金額を言い切る（10/26）。戻り値 [pro, con]。米国は国内なので何も出さない
  const DU = window.YJ_DUTY;
  const rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
  const unitJ = (data.variants[0].p || 0) / 100 / rate;   // 1 枚の値段（円）
  const est = n => DU.estimate(data.country, [{ goods: unitJ * n, n, from: 'US' }]);
  const dutyOf = cc => {
    if (cc === 'US') return [[], []];
    if (!DU || !DU.known(cc)) return [[], [T('関税・税金がかかる場合あり', 'Duties or taxes may apply')]];
    const e = est(1);
    return e.hi === 0 ? [[T('受け取り時の関税・税金なし', 'Nothing to pay on delivery')], []] : [[], [T(`受け取り時に${DU.what(e, true)} 約 ${DU.range(e, true)}`, `About ${DU.range(e, false)} ${DU.what(e, false)} on delivery`)]];
  };
  const farDuty = dutyOf(data.country);
  // 近くの工場から届く分。米国は関税の話を出さない（#9）
  const nearPro = k => (k === 'US' ? [] : [T('関税なし', 'No import duties')]).concat([days(DAYS.near[k])]);
  const labs = [...pick.querySelectorAll('.sw')];
  const nearL = NEAR && !data.jp ? labs.filter(l => nearColor(l.dataset.color)) : [];
  const farL = labs.filter(l => !nearL.includes(l));
  const routes = [];
  // 形の言葉ではなく S の身幅で比べる（10/27 本人指示）。米国 CC1717 46 cm／日本 Printstar 49 cm／旧日本 United Athle 55 cm
  const widthS = cm => T(`S の身幅 ${cm} cm`, `S: ${cm} cm wide`);
  const jpW = ps => widthS(ps ? 49 : 55), usW = widthS(46);
  const oversize = jpW(data.ps);
  if (nearL.length && farL.length) {
    routes.push({ key: 'near', title: T(`${placeOf(NEAR)}の工場から`, `Printed in ${placeOf(NEAR)}`), labs: nearL,
      pro: nearPro(NEAR), info: [T(`${nearL.length} 色`, `${nearL.length} colors`)], con: [] });
    routes.push({ key: 'far', title: T('米国の工場から', 'Printed in the US'), labs: farL,
      pro: farDuty[0], info: [T(`ほかの ${farL.length} 色`, `${farL.length} more colors`)], con: [...farDuty[1], days(farDays)] });
  } else if (data.alt && !data.jp) {   // 通常版の半袖（日本・東アジア）: 近いのは日本版
    const jpNear = data.country === 'JP';
    routes.push({ key: 'alt', title: T('日本の工場から', 'Printed in Japan'), href: data.alt.url,
      pro: jpNear ? nearPro('JP') : [T('日本から発送', 'Ships from Japan'), ...farDuty[0]],
      info: [jpW(data.alt.ps), T(`${data.alt.colors} 色`, `${data.alt.colors} colors`)].concat(jpNear ? [] : [T('目安 1〜2 週間', 'About 1–2 weeks')]), con: jpNear ? [] : farDuty[1] });
    routes.push({ key: 'far', title: T('米国の工場から', 'Printed in the US'), labs, here: true,
      pro: farDuty[0], info: [usW, T(`${labs.length} 色`, `${labs.length} colors`)], con: [...farDuty[1], days(farDays)] });
  } else if (data.alt && data.jp && data.ea) {   // 日本版の半袖: もう一方は米国の通常版
    const jpNear = data.country === 'JP';
    routes.push({ key: 'near', title: T('日本の工場から', 'Printed in Japan'), labs, here: true,
      pro: jpNear ? nearPro('JP') : [T('日本から発送', 'Ships from Japan'), ...farDuty[0]],
      info: [oversize, T(`${labs.length} 色`, `${labs.length} colors`)].concat(jpNear ? [] : [T('目安 1〜2 週間', 'About 1–2 weeks')]), con: jpNear ? [] : farDuty[1] });
    routes.push({ key: 'alt', title: T('米国の工場から', 'Printed in the US'), href: data.alt.url,
      pro: farDuty[0], info: [usW, T(`${data.alt.colors} 色`, `${data.alt.colors} colors`)],
      con: [...farDuty[1], days(jpNear ? DAYS.far.JP : DAYS.far.WORLD)] });
  }
  window.__yjRoutes = routes.length > 0;
  {
    const dd = document.querySelector('[data-yj-dutyspec]'), cc = data.country;
    const dom = cc === 'US' || (data.jp && cc === 'JP');
    if (dd && DU && DU.known(cc) && !dom && !blocked) {   // 日本版が届かない国（blocked）は金額を出さない
      const ex = [1, 2, 3].map(est);
      const none = ex.every(e => e.hi === 0);
      const head = (NEAR && NEAR !== 'CA' && !data.jp && labs.some(l => nearColor(l.dataset.color))) ? T(`${placeOf(NEAR)}の工場から届く分はかかりません。`, `Nothing for items printed in ${placeOf(NEAR)}. `) : '';
      dd.textContent = head + DU.t[cc][ja ? 0 : 1] + (none ? '' : ' ' + T('この商品の目安（受け取り時）: ', 'For this item, due on delivery: ')
        + ex.map((e, i) => T(`${i + 1} 枚 ${e.hi === 0 ? 'なし' : '約 ' + DU.range(e, true)}`, `${i + 1} pc ${e.hi === 0 ? 'none' : 'about ' + DU.range(e, false)}`)).join(T('・', ' · ')) + T('。', '.'));
    }
  }
  let route = null;
  if (routes.length) {
    form.querySelectorAll('.bb__alt').forEach(a => a.remove());
    const box = document.createElement('div');
    box.className = 'route'; box.setAttribute('role', 'radiogroup'); box.setAttribute('aria-label', T('届け方', 'How it ships'));
    box.innerHTML = `<p class="route__q">${T('どこの工場から届けますか？', 'Where should it be printed?')}</p>` + routes.map(r =>
      `<${r.href ? 'a' : 'button type="button"'} class="route__opt" data-route="${r.key}"${r.href ? ` href="${r.href}"` : ''} role="${r.href ? 'link' : 'radio'}">
        <i class="route__dot" aria-hidden="true"></i><b><span class="route__t">${r.title}</span>${r.href ? `<small>${T('別の商品ページへ', 'Opens the other version')}</small>` : ''}</b><ul class="chips">${r.pro.map(t => `<li class="pro">${t}</li>`).join('')}${r.con.map(t => `<li class="con">${t}</li>`).join('')}${(r.info || []).map(t => `<li class="info">${t}</li>`).join('')}</ul>${r.href ? '<i class="route__go" aria-hidden="true">→</i>' : ''}
      </${r.href ? 'a' : 'button'}>`).join('');
    pick.closest('.bb__colors').before(box);
    const apply = key => {
      route = routes.find(r => r.key === key && r.labs) || route;
      box.querySelectorAll('.route__opt').forEach(o => { const on = o.dataset.route === route.key; o.classList.toggle('is-on', on); if (!o.href) o.setAttribute('aria-checked', on); });
      labs.forEach(l => { l.hidden = !route.labs.includes(l) && l.dataset.color !== st.color; });
      form.querySelector('.bb__label--color em').textContent = `${route.labs.length} ${T('色', route.labs.length === 1 ? 'color' : 'colors')}`;
    };
    box.addEventListener('click', e => {
      const o = e.target.closest('button.route__opt'); if (!o) return;
      apply(o.dataset.route);
      if (!route.labs.some(l => l.dataset.color === st.color)) {   // 今の色がこの工場に無ければ、この工場の最初の色へ
        const l = route.labs.find(x => data.variants.some(v => v.color === x.dataset.color && v.size === st.size && v.available)) || route.labs[0];
        l.querySelector('input').checked = true; set({ color: l.dataset.color });
      }
    });
    const startKey = (routes.find(r => r.labs && r.labs.some(l => l.dataset.color === st.color)) || routes.find(r => r.labs)).key;
    apply(startKey);
    // サイズを選んだら、そのサイズを実際に刷る工場へ選択肢を合わせる（「日本の工場から」で刷れないサイズ → 米国側。#18）
    fns.push(changed => {
      if (!changed.includes('size') && !changed.includes('color')) return;
      if (!st.size || !NEAR || !routes.some(r => r.key === 'near' && r.labs) || !routes.some(r => r.key === 'far' && r.labs)) return;
      const want = nearAt(st.color, st.size) ? 'near' : 'far';
      if (route && route.key !== want) apply(want);
    });
  }
  // 近くの工場で作れる色が無い国（例: AU の半袖）は選択肢を出さず、購入ボタン上の配送の箱（renderShip）だけで伝える。旧「全色 米国の工場から」の 1 行は 10/26 に削除
  const pop = lab => { lab.classList.remove('is-pop'); void lab.offsetWidth; lab.classList.add('is-pop'); };
  form.addEventListener('change', e => {
    const r = e.target;
    if (r.name === 'yj-color') { pop(r.closest('label')); set({ color: r.value }); }
    if (r.name === 'yj-size') { pop(r.closest('label')); set({ size: r.value }); }
  });

  // ---- 価格・ボタン・ラベル・URL ----
  const sync = () => {
    const v = variant();
    form.querySelector('[data-colorname]').textContent = st.color;
    { const z = form.querySelector('[data-size]'); z.textContent = st.size || T('未選択', 'Not selected'); z.classList.toggle('is-none', !st.size); }
    // 色名の横の小さな写真は、いつも選んでいる色に合わせる（背面版は背面。#17）
    { const sm = (data.back_first && data.backs[st.color]) ? data.backs[st.color][1] : (data.variants.find(x => x.color === st.color && x.front_sm) || {}).front_sm; if (sm && mini && mini.getAttribute('src') !== sm) mini.src = sm; }
    form.style.setProperty('--c', hexOf(st.color));
    for (const r of form.querySelectorAll('input[name=yj-size]')) {
      const has = data.variants.some(x => x.color === st.color && x.size === r.value && x.available);
      const lab = r.closest('label'), exists = data.variants.some(x => x.color === st.color && x.size === r.value);
      lab.classList.toggle('is-out', !has);
      lab.classList.toggle('is-near', nearAt(st.color, r.value));
      lab.title = exists ? (has ? '' : (ja ? '在庫なし' : 'Sold out')) : (ja ? 'この色にはこのサイズがありません' : 'Not made in this color');
      r.checked = r.value === st.size;
    }
    const ok = !!(v && v.available) && !blocked && !na;
    // 無い組み合わせ・在庫なしのときは id を空にして、上のボタンも下端の帯のボタンも押せなくする（前に選んでいたサイズが入る事故を防ぐ）
    idInput.value = ok ? v.id : '';
    if (v) for (const el of document.querySelectorAll('[data-price], .bar__price')) el.textContent = v.price;
    cta.disabled = !ok; cta.classList.toggle('is-off', !ok);
    const msg = ok ? T('カートに入れる', 'Add to cart') : na ? T('お住まいの国にはお届けできません', 'Not available in your country') : blocked ? T('お届けできない地域です', 'Not available in your region')
      : !st.size ? T('サイズを選んでください', 'Select a size') : !v ? T('このサイズはありません', 'Not made in this size') : T('在庫なし', 'Sold out');
    form.querySelector('[data-ctatext]').textContent = msg;
    // EU・英国は Etsy へ（snippets/yj-geo.liquid が window.YJ_ETSY を入れる。10/26）。
    // 商品ごとの Etsy ボタン（[data-etsy]）は ETSY_BTN が true か ?preview=etsy のときだけ出し、EU・英国と分かれば主のボタンに。
    // それ以外のときは、これまでどおり止めたボタンの下にお店への文字リンク
    const eb = form.querySelector('[data-etsy]');
    // 10/26 本人「Etsy 重複してる」→ 国選択の下に帯（data-etsy-shipto）があるので、下のボタンは EU・英国と判定されたとき（購入ボタンが止まるとき）だけ
    if (eb && (ETSY_BTN || /[?&]preview=etsy\b/.test(location.search))) {
      eb.hidden = !(na && window.YJ_ETSY);
      eb.classList.toggle('is-main', !!(na && window.YJ_ETSY));
      eb.classList.toggle('btn3d--ghost', !(na && window.YJ_ETSY));
    } else if (na && window.YJ_ETSY && !form.querySelector('.bb__etsy-lk')) {
      const a = document.createElement('a');
      a.className = 'bb__etsy-lk'; a.href = window.YJ_ETSY; a.target = '_blank'; a.rel = 'noopener';
      a.style.cssText = 'display:block;margin-top:12px;font-weight:600;text-align:center;text-underline-offset:3px';
      a.textContent = T('EU・英国からは Etsy のお店で買えます ↗', 'In the EU or UK? Buy it on my Etsy shop ↗');
      cta.after(a);
    }
    { const bt = bar.querySelector('[data-bartext]'); if (bt) bt.textContent = ok ? T('買う', 'Buy') : msg; }
    // 追従バー: サイズ未選択のときは押すとサイズの欄へ（押せる）。お届けできない国・在庫なしは押せない
    { const bc = bar.querySelector('.bar__cta'); if (bc) { bc.classList.toggle('is-off', !ok); bc.disabled = !ok && !(!st.size && !na && !blocked); } }
    { const u = new URL(location.href); if (v) u.searchParams.set('variant', v.id); else u.searchParams.delete('variant'); history.replaceState(null, '', u); }
    { const sz = form.querySelector('.bb__sizes'), n = sz.querySelectorAll('.sz.is-near').length, mixed = n > 0 && n < sz.querySelectorAll('.sz:not(.is-out)').length;
      sz.classList.toggle('is-mixed', mixed);
      // 点の凡例（#18）
      const lg = form.querySelector('[data-legend]');
      if (lg) { lg.hidden = !mixed; lg.querySelector('span').textContent = T(`${placeOf(NEAR)}の工場で刷れるサイズ（点なしは米国の工場から）`, `Sizes printed in ${placeOf(NEAR)} (no dot: printed in the US)`); } }
    renderShip();
    // サイズ表: 選んでいるサイズの列を塗る（yj-motion.css の .is-pick）
    { const tb = document.querySelector('.sizet');
      if (tb) { const hs = [...tb.querySelectorAll('thead th')].map(th => th.textContent.trim()), k = st.size ? hs.indexOf(st.size) : -1;
        tb.querySelectorAll('tr').forEach(tr => [...tr.children].forEach((c, i) => c.classList.toggle('is-pick', i === k && k > 0))); } }
    bar.querySelector('.bar__sw').style.background = hexOf(st.color);
    bar.querySelector('.bar__sel').textContent = `${st.color} · ${st.size || T('サイズ未選択', 'no size yet')}`;
  };
  const bar = document.getElementById('bar');

  // ---- 選んだ色・サイズの出荷元・日数・関税（購入ボタンのすぐ上）----
  const shipEl = form.querySelector('[data-ship]');
  const noteEl = form.querySelector('.bb__price-note');
  function renderNote(from) {
    const cc = data.country;
    if (!noteEl || !DU || !DU.known(cc) || cc === 'US') return;
    const base = cc === 'JP' ? T('税込 ＋ 送料 776円', 'Tax incl. + ¥776 shipping') : T('＋ 送料（購入手続きで計算）', '+ shipping (at checkout)');
    let tail;
    if (from === 'DOM') tail = T(' · 関税なし', ' · no import duties');
    else { const e = est(1); tail = e.hi === 0 ? T(' · 受け取り時の関税・税金なし', ' · nothing to pay on delivery') : T(` ＋ 受け取り時に${DU.what(e, true)} 約 ${DU.range(e, true)}`, ` + about ${DU.range(e, false)} ${DU.what(e, false)} on delivery`); }
    noteEl.textContent = base + tail;
  }
  function renderShip() {
    if (!blocked) {
      const nr = st.size ? nearAt(st.color, st.size) : nearColor(st.color);
      renderNote((data.jp && data.country === 'JP') || nr ? 'DOM' : 'US');
    }
    if (!shipEl) return;
    if (blocked) {
      shipEl.className = 'yj-ship is-us';
      shipEl.innerHTML = ja ? '<b>お届けできない地域です</b><span>このモデルは日本と東アジア（韓国・台湾・香港・シンガポール・タイ・ベトナム・マレーシア・フィリピン・インドネシア）へのお届けのみです。通常版をお選びください。</span>'
                            : '<b>Not available in your region</b><span>This shirt ships to Japan and East Asia only. Please choose the regular tee.</span>';
      return;
    }
    // サイズ未選択のときは、その色のどれかのサイズで判断する
    const near = st.size ? nearAt(st.color, st.size) : nearColor(st.color);
    const r = st.size ? regs(st.color, st.size) : [...new Set(sold(st.color).flatMap(v => regs(st.color, v.size)))];
    // ノルウェー・スイスは EU の工場から届く（Printful の振り分け）
    const pref = { NO: 'EU', CH: 'EU' }[data.country];
    const from = near ? NEAR : (pref && r.includes(pref)) ? pref : (r.includes('US') || !r.length ? 'US' : r[0]);
    const T = (j, e) => ja ? j : e, d = x => T(x[0], x[1]);
    // 工場を選ぶ欄があり、選んだ色・サイズがその工場どおりなら、ここは出さない（同じことを 2 回言わない）
    const sizeOff = window.__yjRoutes && NEAR && st.size && nearColor(st.color) && !near;   // 近くの工場の色だが、このサイズは米国から
    if (window.__yjRoutes && !sizeOff) { shipEl.hidden = true; return; }
    shipEl.hidden = false;
    let head, pro = [], con = [];
    if (sizeOff) {
      head = T(`このサイズは${placeOf(from)}の工場から`, `This size is printed in ${placeOf(from)}`);
      pro = farDuty[0]; con = [...farDuty[1], d(NEAR === 'JP' ? DAYS.far.JP : (DAYS.far[NEAR] || DAYS.far.WORLD))];
    } else if (near) {
      head = T(`${placeOf(NEAR)}の工場から`, `Printed in ${placeOf(NEAR)}`);
      pro = nearPro(NEAR);
    } else if (pref) {
      head = T(`${placeOf(from)}の工場から`, `Printed in ${placeOf(from)}`);
      pro = from === pref ? [d(['8〜12 営業日', '8–12 business days'])] : [];
      if (from !== pref) con.push(d(DAYS.far.WORLD));
      con.push(...farDuty[1]);
    } else if (NEAR) {
      head = T(`${placeOf(from)}の工場から`, `Printed in ${placeOf(from)}`);
      pro = farDuty[0]; con = [...farDuty[1], d(NEAR === 'JP' ? DAYS.far.JP : (DAYS.far[NEAR] || DAYS.far.WORLD))];
    } else {
      head = T(`${placeOf(from)}の工場から`, `Printed in ${placeOf(from)}`);
      pro = farDuty[0]; con = [d(DAYS.far.WORLD), ...farDuty[1]];
    }
    shipEl.className = 'yj-ship yj-ship--chips';
    shipEl.innerHTML = `<b>${head}</b><ul class="chips">${pro.map(t => `<li class="pro">${t}</li>`).join('')}${con.map(t => `<li class="con">${t}</li>`).join('')}</ul>`;
  }
  fns.push(sync);

  // ---- ギャラリー: 選んだ色の正面・背面 ----
  const gal = document.getElementById('gal');
  const imgs = gal.querySelectorAll('.gal__img'), cap = gal.querySelector('.gal__cap');
  const thBack = gal.querySelector('[data-kind=back]');
  let kind = data.back_first ? 'back' : 'front', flip = 0;   // 背面プリント版は背中から見せる
  const shots = () => {
    const v = data.variants.find(x => x.color === st.color && x.front) || variant();
    const b = data.backs[st.color];
    return { front: [v.front, v.front_sm], back: b };
  };
  function show(src, caption) {
    const next = imgs[flip ^ 1], prev = imgs[flip];
    const abs = u => { try { const x = new URL(u, location.href); return x.host + x.pathname + x.search.replace(/[?&]width=\d+/, ''); } catch (e) { return u; } };
    // 最初の写真（liquid が srcset 付きで出す）と同じなら差し替えない＝演出を待たずにそのまま見せる
    if (abs(prev.currentSrc || prev.src) === abs(src) || abs(prev.getAttribute('src') || '') === abs(src)) { cap.textContent = caption; return; }
    next.removeAttribute('srcset'); next.src = src; next.alt = caption;
    const go = () => { next.classList.add('is-on'); prev.classList.remove('is-on'); flip ^= 1; };
    if (next.complete && next.naturalWidth) go(); else next.addEventListener('load', go, { once: true });
    cap.textContent = caption;
  }
  function renderGal() {
    const s = shots();
    gal.querySelector('[data-kind=front] img').src = s.front[1];
    thBack.hidden = !s.back;
    if (s.back) thBack.querySelector('img').src = s.back[1];
    if (kind === 'back' && !s.back) kind = 'front';
    const label = kind === 'front' ? (ja ? '正面' : 'Front') : (ja ? '背面' : 'Back');
    show((kind === 'front' ? s.front : s.back)[0], `${st.color} · ${label}`);
    for (const b of gal.querySelectorAll('.gal__th')) b.classList.toggle('is-on', b.dataset.kind === kind);
  }
  gal.querySelector('.gal__thumbs').addEventListener('click', e => {
    const b = e.target.closest('.gal__th'); if (!b) return;
    kind = b.dataset.kind;
    if (kind === 'photo') {   // 部屋で撮った実写（色に関係なく出す）
      imgs.forEach(i => i.classList.add('gal__img--photo'));
      const ph = [...gal.querySelectorAll('.gal__th--photo')], n = ph.indexOf(b) + 1;
      // ロンT・日本版のページでは、写っているのが米国で刷る半袖だと添える（10/26 点検 #15）
      const note = (data.ls || data.jp) ? T(' · 写真は米国で刷る半袖', ' · photo: US-printed tee') : '';
      show(b.dataset.src, `${ja ? '部屋で' : 'In the room'} · ${n} / ${ph.length}${note}`);
      imgs.forEach(i => { if (i.src === b.dataset.src) i.alt = b.dataset.alt; });
      for (const t of gal.querySelectorAll('.gal__th')) t.classList.toggle('is-on', t === b);
      return;
    }
    imgs.forEach(i => i.classList.remove('gal__img--photo'));
    renderGal();
  });
  // 切り替わったことに気づけるように: 色名の横の小さな写真・大きい写真・説明札・色名を一度だけ弾ませる
  const mini = form.querySelector('[data-mini]'), cname = form.querySelector('[data-colorname]');
  const bump = el => { if (!el || reduce.matches) return; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); };
  fns.push(changed => {
    if (!changed.includes('color')) return;
    [mini, cname, cap, gal.querySelector('.gal__main')].forEach(bump);
  });
  fns.push(changed => { if (changed.includes('color')) { if (kind === 'photo') { kind = 'front'; imgs.forEach(i => i.classList.remove('gal__img--photo')); } renderGal(); } });

  // ---- SP: 購入ボタンが画面外のときだけ下端の帯 ----
  const toBuy = () => form.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
  bar.querySelector('.bar__sw').addEventListener('click', toBuy);
  bar.querySelector('.bar__txt').addEventListener('click', toBuy);
  bar.querySelector('.bar__cta').addEventListener('click', e => {
    if (st.size || na || blocked) return;
    e.preventDefault();
    const sz = form.querySelector('.bb__row--size');
    sz.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' });
    sz.classList.remove('is-ask'); void sz.offsetWidth; sz.classList.add('is-ask');
  });
  new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting), { threshold: 0 }).observe(cta);

  // ---- 部屋 ----
  const main = document.getElementById('pdp'), room = document.getElementById('room3');
  const $ = s => room.querySelector(s);
  const cham = $('.m--chameleon');
  // KV の 1440×900 での左上（トップの部屋と同じ値）。床の線は y505、塊の範囲は x518〜1455 / y19〜811
  const KV = [
    ['.m--plant', 1042, 18.99], ['.m--clock', 613.212, 109.19], ['.m--headphones', 674, 686], ['.m--cup', 542, 686],
    ['.m--speaker', 769.622, 347.316], ['.m--lamp', 781.027, 218.228], ['.m--record', 844, 468], ['.m--mixer', 864, 473],
    ['.m--player', 1001.137, 457.295], ['.m--shadow', 518, 313], ['.m--chameleon', 518, 313],
  ];
  const KV_X0 = 518, KV_W = 1455 - 518, KV_Y0 = 19, KV_Y1 = 811, KV_FLOOR = 505;
  const put = (el, X, Y, f) => { el.style.setProperty('--f', f); el.style.setProperty('--x', X + 'px'); el.style.setProperty('--y', Y + 'px'); };
  function place() {
    const sp = innerWidth <= 1080;
    const mr = main.getBoundingClientRect();
    const g0 = gal.querySelector('.gal__main').getBoundingClientRect(), gw0 = gal.getBoundingClientRect(), b0 = form.getBoundingClientRect();
    const rel = r => ({ left: r.left - mr.left, top: r.top - mr.top, right: r.right - mr.left, bottom: r.bottom - mr.top, width: r.width });
    const g = rel(g0), gw = rel(gw0), b = rel(b0);
    const f = sp ? Math.min(.5, (mr.width - 24) / KV_W) : Math.max(.56, Math.min(.78, g.width / 720));
    // 壁: 釘と紐（商品写真の額を掛ける）
    const hang = $('#hang');
    const nx = g.left + g.width / 2, ny = g.top - 48 * f - 8;
    hang.querySelector('.hang__nail').setAttribute('cx', nx); hang.querySelector('.hang__nail').setAttribute('cy', ny);
    hang.querySelector('.hang__string').setAttribute('d', `M${g.left + 28} ${g.top + 1} L${nx} ${ny + 4} L${g.right - 28} ${g.top + 1}`);
    // 部屋: KV の並びを 1 つの塊で、ギャラリーと購入欄の下・横中央に（T シャツの絵と同じ構図）
    const top = Math.max(gw.bottom, b.bottom) + (sp ? 32 : 48);
    const ox = (mr.width - KV_W * f) / 2 - KV_X0 * f, oy = top - KV_Y0 * f;
    for (const [sel, x, y] of KV) put($(sel), ox + x * f, oy + y * f, f);
    // 湯気（60×70 の箱）は下端の中央を軸に f 倍するので、その軸がカップの上（設計の 586, 696）に来るように置く。
    // 以前は左上を縮めた座標に置いていたため、絵が小さい SP ほど湯気がカップから離れていた（10/26）
    const steam = $('.steam'); steam.style.setProperty('--x', ox + 586 * f - 30 + 'px'); steam.style.setProperty('--y', oy + 696 * f - 70 + 'px'); steam.style.setProperty('--f', f);
    room.style.setProperty('--fy', oy + KV_FLOOR * f + 'px');
    main.style.paddingBottom = Math.round(oy + KV_Y1 * f - Math.max(gw.bottom, b.bottom) + 40) + 'px';
  }
  const ro = new ResizeObserver(() => requestAnimationFrame(place));
  ro.observe(gal); ro.observe(form); ro.observe(main);
  addEventListener('resize', place); addEventListener('load', place);
  document.fonts?.ready.then(place);
  place();

  // 2 小節だけ「鳴る」（カメレオン・スピーカーがノる）／触る
  function groove(bars = 2) {
    if (reduce.matches) return;
    room.classList.add('is-playing');
    clearTimeout(room.__gt);
    room.__gt = setTimeout(() => room.classList.remove('is-playing'), 1666 * bars);
  }
  function poke(m, k) {
    if (reduce.matches) return;
    const p = m.querySelector('.p'); if (!p || p.className.includes('is-')) return;
    p.classList.add('is-' + k);
    p.addEventListener('animationend', e => { if (e.target === p) p.classList.remove('is-' + k); }, { once: true });
  }
  for (const el of room.querySelectorAll('[data-poke]')) {
    const k = el.dataset.poke, hoverK = k === 'flip' ? 'jelly' : k;
    el.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') poke(el, hoverK); });
    el.addEventListener('pointerdown', e => { if (k === 'flip') { el.querySelector('.p').classList.remove('is-jelly'); poke(el, 'flip'); } else if (e.pointerType !== 'mouse') poke(el, k); });
  }
  // 画面外では止める
  new IntersectionObserver(([e]) => room.classList.toggle('is-off', !e.isIntersecting)).observe(main);
  document.addEventListener('visibilitychange', () => room.classList.toggle('is-off', document.hidden));

  // 色でカメレオンが変わって 2 小節ノる、サイズでうなずく。買うボタンに触れている間は鳴り続ける
  room.style.setProperty('--cham', chamOf(st.color));
  fns.push(changed => {
    if (changed.includes('color')) { room.style.setProperty('--cham', chamOf(st.color)); groove(2); poke(cham, 'jelly'); }
    if (changed.includes('size')) poke(cham, 'jelly');
  });
  cta.addEventListener('pointerenter', () => { if (!reduce.matches) { clearTimeout(room.__gt); room.classList.add('is-playing'); } });
  cta.addEventListener('pointerleave', () => groove(1));

  // 買う: 宙返りしながら、ページを移らずにカートへ入れて「カートに入れました」の小窓を出す（10/26。まとめて買う人がそのまま選び続けられるように。
  // ページを移らないので流している音も止まらない）。ヘッダーのカートは袋が揺れて数のバッジが跳ねる
  let going = false;
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (cta.disabled || !idInput.value) return;
    addInPlace();
  });
  const cartUrl = form.action.replace(/\/add\/?$/, '');
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  let cpop = null, lastFocus = null;
  function closePop() {
    if (!cpop || !cpop.classList.contains('is-on')) return;
    cpop.classList.remove('is-on'); document.documentElement.classList.remove('yj-cpop-open');
    setTimeout(() => { if (cpop && !cpop.classList.contains('is-on')) cpop.hidden = true; }, 260);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  function openPop(v, count) {
    if (!cpop) {
      cpop = document.createElement('div');
      cpop.className = 'yj-cpop'; cpop.hidden = true;
      cpop.innerHTML = `<div class="yj-pop__bg" data-close></div><div class="yj-pop__box" role="dialog" aria-modal="true" aria-labelledby="yj-cpop-h" tabindex="-1">
        <button type="button" class="yj-pop__x" data-close aria-label="${ja ? '閉じる' : 'Close'}">×</button>
        <p class="yj-pop__h" id="yj-cpop-h"><span class="yj-pop__ok" aria-hidden="true">✓</span>${ja ? 'カートに入れました' : 'Added to your cart'}</p>
        <div class="yj-pop__item"><img alt="" width="88" height="88"><div><b class="yj-pop__name"></b><span class="yj-pop__opt"></span><span class="yj-pop__price"></span></div></div>
        <p class="yj-pop__count"></p>
        <div class="yj-pop__btns"><button type="button" class="btn3d btn3d--ghost yj-pop__more" data-close>${ja ? '買い物を続ける' : 'Keep shopping'}</button><a class="btn3d yj-pop__go" href="${cartUrl}">${ja ? 'カートを見る' : 'View cart'}</a></div>
      </div>`;
      document.body.append(cpop);
      cpop.addEventListener('click', e => { if (e.target.closest('[data-close]')) closePop(); });
      addEventListener('keydown', e => { if (e.key === 'Escape') closePop(); });
    }
    const sm = (data.back_first && data.backs[v.color]) ? data.backs[v.color][1] : (data.variants.find(x => x.color === v.color && x.front_sm) || {}).front_sm;
    const img = cpop.querySelector('img'); if (sm) img.src = sm;
    cpop.querySelector('.yj-pop__name').textContent = (document.querySelector('.bb__title') || {}).textContent || '';
    cpop.querySelector('.yj-pop__opt').textContent = `${v.color} · ${v.size}`;
    cpop.querySelector('.yj-pop__price').textContent = v.price;
    cpop.querySelector('.yj-pop__count').innerHTML = ja ? `カートの中: <b>${esc(count)}</b> 点` : `In your cart: <b>${esc(count)}</b> item${count === 1 ? '' : 's'}`;
    lastFocus = document.activeElement;
    cpop.hidden = false; document.documentElement.classList.add('yj-cpop-open');
    requestAnimationFrame(() => requestAnimationFrame(() => { cpop.classList.add('is-on'); cpop.querySelector('.yj-pop__go').focus({ preventScroll: true }); }));
  }
  async function addInPlace() {
    if (going) return;
    going = true;
    const v = variant();
    if (!reduce.matches) { poke(cham, 'flip'); groove(1); }
    const note = form.querySelector('.bb__added') || form.querySelector('.bb__foot').appendChild(Object.assign(document.createElement('p'), { className: 'bb__added' }));
    note.setAttribute('aria-live', 'polite'); note.textContent = ''; note.className = 'bb__added';
    try {
      const r = await fetch(form.action.replace(/\/?$/, '') + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || r.status);
      const cart = await (await fetch(cartUrl + '.js')).json();
      for (const link of document.querySelectorAll('[data-cartlink]')) {
        link.classList.toggle('has-items', cart.item_count > 0);
        link.setAttribute('aria-label', ja ? `カート（${cart.item_count} 点）` : `Cart (${cart.item_count} item${cart.item_count === 1 ? '' : 's'})`);
        const n = link.querySelector('[data-cart-count]'); if (n) n.textContent = cart.item_count;
        link.classList.remove('is-bump'); void link.offsetWidth; link.classList.add('is-bump');   // 袋が揺れてバッジが跳ねる（yj-motion.css）
      }
      // 宙返りを見せてから小窓（動きを減らす設定ならすぐ）
      setTimeout(() => openPop(v, cart.item_count), reduce.matches ? 0 : 520);
    } catch (err) {
      note.className = 'bb__added is-ng';
      note.textContent = (ja ? 'カートに入れられませんでした: ' : 'Could not add to cart: ') + err.message;
    } finally { going = false; }
  }

  // コピーガード: 画像の右クリック・ドラッグを止める（保存の手間を増やすだけで、完全には防げない）
  document.addEventListener('contextmenu', e => { if (e.target.closest('img, .room, .gal__main')) e.preventDefault(); });
  document.addEventListener('dragstart', e => { if (e.target.tagName === 'IMG') e.preventDefault(); });

  sync(); renderGal();
  document.body.classList.add('is-ready');
  window.__ready = true;
})();
